import styled from 'styled-components';
import { width } from '../SaveButton';

export default styled.div`
  font-weight: bold;
  font-size: 1.5rem;
  line-height: calc(60px / 2);
  float: left;
  width: ${`calc(100% - ${width})`};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
